import { StubPage } from "./stub-page";

export function HomePage() {
  return (
    <StubPage
      title="Home"
      description="This is the PCG Platform bootstrap's home route — the first real page rendered inside the shared AppShell from nazare-ui."
    />
  );
}
